import { SecuritySettingsData } from "../../../models/securitySettingsData";

/**
 * Represents the state for security settings in the Redux store.
 */
export interface SecuritySettingsState {
  securitySettings: SecuritySettingsData;
  isLoading: boolean;
  error: boolean;
  isLoaded: boolean;
}

/**
 * Action type dispatched when security settings request starts.
 */
export const SECURITY_SETTINGS_REQUEST = "SECURITY_SETTINGS_REQUEST";

/**
 * Action type dispatched when security settings is successfully fetched.
 */
export const SECURITY_SETTINGS_SUCCESS = "SECURITY_SETTINGS_SUCCESS";

/**
 * Action type dispatched when there is an error fetching security settings.
 */
export const SECURITY_SETTINGS_FAILURE = "SECURITY_SETTINGS_FAILURE";

/**
 * Action for initiating a security settings fetch request.
 */
export interface SecuritySettingsRequestAction {
  type: typeof SECURITY_SETTINGS_REQUEST;
}

/**
 * Action for handling a failed security settings fetch request.
 */
export interface SecuritySettingsFailureAction {
  type: typeof SECURITY_SETTINGS_FAILURE;
}

/**
 * Action for handling a successful security settings fetch.
 */
export interface SecuritySettingsSuccessAction {
  type: typeof SECURITY_SETTINGS_SUCCESS;
  data: SecuritySettingsData;
}

/**
 * Union type for all possible security settings action types.
 */
export type SecuritySettingsActionTypes =
  | SecuritySettingsRequestAction
  | SecuritySettingsSuccessAction
  | SecuritySettingsFailureAction;
